
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 209.9 183.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-width":".75","stroke-miterlimit":"10","d":"M94.6 16.1h20.7v8.4H94.6zM79 166.3c0-14.3 11.6-25.9 25.9-25.9s25.9 11.6 25.9 25.9M104.9 81.7c-8.5 0-16-4.1-20.7-10.3h41.5c-4.8 6.2-12.3 10.3-20.8 10.3z"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-width":".75","stroke-miterlimit":"10","d":"M19.9 24.5H190v141.8H19.9z"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-width":".75","stroke-miterlimit":"10","d":"M79 24.6h51.9v15.6H79z"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-width":".75","stroke-miterlimit":"10","d":"M47.8 24.6H162v46.8H47.8z"}}),_c('circle',{attrs:{"cx":"104.9","cy":"55.7","r":".7","fill":"#fff"}}),_c('circle',{attrs:{"cx":"104.9","cy":"166.3","r":".9","fill":"#fff"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-width":".5","stroke-miterlimit":"10","stroke-dasharray":"4,4","d":"M47.8 71.4v94M162 71.4v94M130.9 40.2H190M79 40.2H19.9M47.8 71.4H19.9M162 71.4h28"}})])
          )
        }
      }
    